import { createRoot } from "react-dom/client";
import { App } from "./App";

document.querySelectorAll('.calculadora_meuselfstorage').forEach((item) => {
    const root = createRoot(item, {});
    root.render(<App />);
});
